import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Navigate, Route, Routes, useParams } from 'react-router-dom';
import { getServiceBySlug } from './data/services';
import SiteLayout from './components/SiteLayout';
import ScrollToTop from './components/ScrollToTop';
import { conditions } from './data/conditions';
import { services } from './data/services';
import './styles/site.css';

const HomePage = lazy(() => import('./pages/HomePage'));
const TestimonialsPage = lazy(() => import('./pages/TestimonialsPage'));
const AboutPage = lazy(() => import('./pages/AboutPage'));
const HowItWorksPage = lazy(() => import('./pages/HowItWorksPage'));
const ServicesPage = lazy(() => import('./pages/ServicesPage'));
const ServiceDetailPage = lazy(() => import('./pages/ServiceDetailPage'));
const ContactPage = lazy(() => import('./pages/ContactPage'));
const ConditionsPage = lazy(() => import('./pages/ConditionsPage'));
const ConditionDetailPage = lazy(() => import('./pages/ConditionDetailPage'));
const PoliciesPage = lazy(() => import('./pages/PoliciesPage'));
const PolicyViewPage = lazy(() => import('./pages/PolicyViewPage'));
const NotFoundPage = lazy(() => import('./pages/NotFoundPage'));

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <SiteLayout>
        <Suspense fallback={<div className="container py-5">Loading page...</div>}>
          <Routes>
            <Route path="/" element={<Navigate replace to="/physiotherapy-bradford" />} />
            <Route path="/physiotherapy-bradford" element={<HomePage />} />
            <Route path="/home" element={<Navigate replace to="/physiotherapy-bradford" />} />
            <Route path="/testimonials" element={<TestimonialsPage />} />
            <Route path="/about-us" element={<AboutPage />} />
            <Route path="/about" element={<Navigate replace to="/about-us" />} />
            <Route path="/how-it-works" element={<HowItWorksPage />} />
            <Route path="/services" element={<ServicesPage />} />
            {services.map((service) => (
              <Route key={service.path} path={service.path} element={<ServiceDetailPage />} />
            ))}
            <Route path="/contact-us" element={<ContactPage />} />
            <Route path="/contact" element={<Navigate replace to="/contact-us" />} />
            <Route path="/conditions" element={<ConditionsPage />} />
            {conditions.map((condition) => (
              <Route key={condition.path} path={condition.path} element={<ConditionDetailPage />} />
            ))}
            <Route path="/policies" element={<PoliciesPage />} />
            <Route path="/policies/:policyId" element={<PolicyViewPage />} />
            <Route
              path="/services/:serviceSlug"
              element={<LegacyServiceRedirect />}
            />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </Suspense>
      </SiteLayout>
    </BrowserRouter>
  );
}

function LegacyServiceRedirect() {
  const { serviceSlug } = useParams();
  const legacySlug = serviceSlug === 'Telehealth' ? 'online-physiotherapy' : serviceSlug;
  const service = getServiceBySlug(legacySlug || '');

  if (service) {
    return <Navigate replace to={service.path} />;
  }

  return <Navigate replace to="/services" />;
}

export default App;
